@let site = site$ | async;
@defer (when site) {
    <div class="flex flex-col">
        <h5>{{ applicationNamePP }}</h5>

        <mds-checkbox
            id="allowInvitationToPatientPortal"
            [formCtrl]="formGrp().controls.allowPPInvitations"
            [label]="`Allow the site's CRCs to invite new patients to ${applicationNamePP}`"
            name="allowPpinvitations"
        />
    </div>
}
